import { useState } from "react";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useTranslation } from "react-i18next";

type EuropcarWhatsIncludedSectionProps = {
  selectedCar?: any;
};

export default function EuropcarWhatsIncludedSection({ selectedCar }: EuropcarWhatsIncludedSectionProps) {
  const [expanded, setExpanded] = useState(false);
  const { t } = useTranslation();
  const included = selectedCar?.included ?? [];

  if (included.length === 0) {
    return null;
  }

  return (
    <Box sx={{ width: "100%", mt: 1.5 }}>
      <Box
        role="button"
        aria-expanded={expanded}
        onClick={() => setExpanded(prev => !prev)}
        sx={{
          display: "inline-flex",
          alignItems: "center",
          gap: 0.25,
          cursor: "pointer",
          color: "success.main",
          fontFamily: "Neutraface2Demi",
          fontSize: 15,
          textTransform: "uppercase"
        }}
        data-cy="europcar-whats-included-toggle"
      >
        {t("transport.whatsIncludedTitle")}
        {expanded ? <KeyboardArrowUpIcon sx={{ fontSize: 20 }} /> : <KeyboardArrowDownIcon sx={{ fontSize: 20 }} />}
      </Box>

      <Collapse in={expanded}>
        <Box sx={{ mt: 1 }}>
          {included.map((item: { description: string }, index: number) => (
            <Box
              key={index}
              sx={{
                display: "flex",
                justifyContent: "space-between",
                gap: 2,
                fontSize: 15,
                lineHeight: 1.6
              }}
            >
              <Box component="span">{item.description}</Box>
              <Box component="span" sx={{ flexShrink: 0 }}>
                {t("transport.europcarInsurance.statusIncluded")}
              </Box>
            </Box>
          ))}
        </Box>
      </Collapse>
    </Box>
  );
}
